export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_batchSize') || '批量范围',
    field: 'batchSize',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return [row.batchMinSize || 0, row.batchMaxSize || 0].join(' - ')
    },
  },
  {
    title: that.$l('table_label_inspectionLevel') || '检验水平',
    field: 'inspectionLevel',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSize') || '抽检数量',
    field: 'sampleSize',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_acceptanceNum') || '合格判定数',
    field: 'acceptanceNum',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createByName') || '创建人',
    field: 'createByName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createTime') || '创建时间',
    field: 'createTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_modifyByName') || '修改人',
    field: 'modifyByName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_modifyTime') || '修改时间',
    field: 'modifyTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
]
